import { ReceiptTemplateMarkupSlimModel } from 'models'
import receiptSettingService from 'Services/api/receiptSetting.service'
import { HttpRequestError } from 'httpRequest/HttpRequest'
import { AppThunk, createDispatchActionSet } from './base.action'

export const getDefaultReceiptTemplateAction = createDispatchActionSet<
    ReceiptTemplateMarkupSlimModel[]
>('GET_DEFAULT_RECEIPT_TEMPLATE')

export const getDefaultReceiptTemplate = (): AppThunk => async (dispatch) => {
    try {
        dispatch(getDefaultReceiptTemplateAction.pending())
        const res = await receiptSettingService.getAllDefaultReceiptMarkup()
        dispatch(getDefaultReceiptTemplateAction.success(res.data))
    } catch (error) {
        dispatch(
            getDefaultReceiptTemplateAction.failed(error as HttpRequestError),
        )
    }
}

export const getAllReceiptMarkupAction = createDispatchActionSet<
    ReceiptTemplateMarkupSlimModel[]
>('GET_ALL_RECEIPT_MARKUP')

export const getAllReceiptMarkup = (): AppThunk => async (dispatch) => {
    try {
        dispatch(getAllReceiptMarkupAction.pending())
        const res = await receiptSettingService.getReceiptMarkup()
        dispatch(getAllReceiptMarkupAction.success(res.data))
    } catch (error) {
        dispatch(getAllReceiptMarkupAction.failed(error as HttpRequestError))
    }
}
